import React, { useContext } from 'react'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import WorkMergeHeader from '@Scenes/RightsholderScene/WorkMerge/WorkMergeHeader'
import WorkMergeRequestList from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestList'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

const WorkMerge = () => {
    const { rightsholderStore, workMergeRequestListStore, workMergeReviewListStore } = useContext(StoresContext)
    const navigate = useNavigate()

    const workMergeTabs: Tab[] = [
        {
            tabName: 'My Merge Requests',
            tabDisplayName: 'My Merge Requests',
            tabComponent: (
                <WorkMergeRequestList
                    key="MY_MERGE_REQUESTS"
                    store={workMergeRequestListStore}
                    dateLabel="Date Submitted"
                    requestPath={Navigation.rightholder.workMerge.request}
                    title="No merge requests yet"
                    description="When you submit a work merge request, it will appear here so you can track its status."
                />
            ),
        },
        {
            tabName: 'For my Review',
            tabDisplayName: 'For my Review',
            tabComponent: (
                <WorkMergeRequestList
                    key="FOR_MY_REVIEW"
                    store={workMergeReviewListStore}
                    dateLabel="Request Date"
                    requestPath={Navigation.rightholder.workMerge.reviewRequest}
                    title="Nothing to review yet"
                    description="When another member submits a work merge request that needs your approval, it will appear here."
                />
            ),
        },
    ]

    return (
        <div className="work-merge-wrapper">
            <WorkMergeHeader />
            <Button
                className="work-merge-start-request"
                mainColor
                type="primary"
                icon={ICONS.add}
                onClick={() =>
                    navigate(Navigation.rightholder.workMerge.newMergeRequest(rightsholderStore.currentRightsholderId))
                }
            >
                Start Work Merge Request
            </Button>
            <div className="work-merge-tabs">
                <TabsWrapperComponent tabs={workMergeTabs} defaultTab={workMergeTabs[0]} preventScrollReset />
            </div>
        </div>
    )
}

export default WorkMerge
